/* AnrixAuto — product page variant sync.
 *
 * Why this file exists:
 * sections/main-product.liquid renders its <script data-variant-json> block
 * OUTSIDE the [data-product-root] wrapper. theme.js's initVariantPickers()
 * scopes its lookup to that wrapper, finds nothing, and returns before it
 * binds any change handler — so on the product page the picker was inert:
 * price, SKU, stock, gallery and the hidden line-item id all stayed on the
 * first variant no matter which option was clicked.
 *
 * This script owns the picker on the main product section only. quick-add
 * nests its JSON correctly inside [data-product-root] and is still driven by
 * theme.js, so the two never collide.
 *
 * The clean fix is to move that <script> inside [data-product-root] in
 * sections/main-product.liquid and delete this file.
 */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('.section-main-product');
    if (!section) return;

    var picker = section.querySelector('[data-variant-picker]');
    var dataEl = section.querySelector('[data-variant-json]');
    if (!picker || !dataEl || picker.__anrixSync) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    picker.__anrixSync = true;

    var priceEl = section.querySelector('[data-price-wrap]');
    var idInput = section.querySelector('[data-variant-id-input]');
    var addBtn  = section.querySelector('[data-add-button]');
    var addText = addBtn && addBtn.querySelector('.btn__text');
    var skuEl   = section.querySelector('[data-variant-sku]');
    var stockEl = section.querySelector('[data-variant-stock]');

    function chosen() {
      return Array.prototype.map.call(
        picker.querySelectorAll('input:checked, select'),
        function (el) { return el.value; }
      );
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function sync() {
      var opts = chosen();
      var v = match(opts);

      Array.prototype.forEach.call(
        picker.querySelectorAll('[data-selected-value]'),
        function (el) {
          var i = parseInt(el.getAttribute('data-selected-value'), 10) - 1;
          if (opts[i]) el.textContent = opts[i];
        }
      );

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-disabled', 'true'); }
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      /* the line item that actually gets added to the cart */
      if (idInput) idInput.value = v.id;

      if (window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* non-fatal */ }
      }

      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;

      if (skuEl) {
        skuEl.textContent = v.sku || '';
        var row = skuEl.closest('[data-sku-row]');
        if (row) row.hidden = !v.sku;
      }

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.setAttribute('aria-disabled', String(!v.available));
        if (addText) addText.textContent = v.available ? 'Add to cart' : 'Sold out';
      }

      if (stockEl) {
        var low = v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5;
        stockEl.className = 'product__stock ' +
          (v.available ? (low ? 'product__stock--low' : 'product__stock--in') : 'product__stock--out');
        stockEl.innerHTML = '<span class="product__stock-dot"></span>' +
          (v.available
            ? (low ? 'Low stock — only ' + v.inventory_quantity + ' left' : 'In stock, ready to ship')
            : 'Sold out');
      }

      if (v.featured_media_id) {
        var id = String(v.featured_media_id);
        var slide = section.querySelector('.gallery__slide[data-media-id="' + id + '"]');
        if (slide) {
          Array.prototype.forEach.call(section.querySelectorAll('.gallery__slide'), function (s) {
            s.classList.toggle('is-active', s === slide);
          });
          Array.prototype.forEach.call(section.querySelectorAll('.gallery__thumb'), function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-media-id') === id);
          });
        }
      }
    }

    picker.addEventListener('change', sync);
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
